import { render, staticRenderFns } from "./MarkReturnedAction.vue?vue&type=template&id=0f19b549&scoped=true"
import script from "./MarkReturnedAction.vue?vue&type=script&lang=js"
export * from "./MarkReturnedAction.vue?vue&type=script&lang=js"
import "./MarkReturnedAction.vue?vue&type=style&index=0&id=0f19b549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19b549",
  null
  
)

export default component.exports